import React from "react";
import { motion } from "framer-motion";

const DEFAULT_ITEMS = [
  {
    image: "https://media.base44.com/images/public/69b41710d6b60acb7a810a52/15a99684b_trophy.png",
    imageSize: "w-[53px] h-[110px]",
    tag: "הפרס הגדול",
    title: "זוג כרטיסים למשחק הפתיחה",
    detail: "גביע העולם 2026 ארה״ב · M04 · CAT 1 Seating (USA vs Paraguay)",
    featured: true,
  },
  {
    image: "https://media.base44.com/images/public/69b41710d6b60acb7a810a52/65c8158e1_tickets.png",
    imageSize: "w-[128px] h-[130px]",
    tag: "500 הזדמנויות",
    title: "כרטיסים לאירועים עולמיים",
    detail: "פורמולה 1 · Tomorrowland · ברצלונה · ריאל מדריד · ליברפול · PSG ועוד",
    featured: false,
  },
  {
    image: "https://media.base44.com/images/public/69b41710d6b60acb7a810a52/ce9a2f142_airline_tickets.png",
    imageSize: "w-[115px] h-[115px]",
    tag: "חבילת חוויה",
    title: "טיסות וחבילות נסיעה",
    detail: "טיסות מוזלות וחבילות נסיעה מלאות למונדיאל דרך קשרי תעופה",
    featured: true,
  },
];

export default function PrizesSection({ config }) {
  const items = config?.cards ?? DEFAULT_ITEMS;
  return (
    <section className="py-20 px-4" style={{ background: "linear-gradient(180deg, #161616 0%, #252525 100%)" }} dir="rtl">
      <div className="max-w-4xl mx-auto">

        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-12"
        >
          <p className="text-xs font-black uppercase tracking-widest mb-3" style={{ color: "#c8f135" }}>מה ניתן לזכות</p>
          <h2 className="font-black mb-3 text-white" style={{ fontSize: "clamp(1.8rem, 4vw, 2.8rem)" }}>
            הפרסים שמחכים לכם
          </h2>
          <p className="text-sm" style={{ color: "#C4C4C4" }}>
            מי שיצבור הכי הרבה פעילויות ב-10 ימי המבצע — יזכה בפרס הגדול
          </p>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-4 mb-8">
          {items.map(({ image, imageSize, tag, title, detail, featured }, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.08 }}
              className="rounded-2xl pt-8 pb-6 px-6 flex flex-col items-center text-center relative overflow-hidden"
              style={{
                background: "#111",
                border: `1px solid ${featured ? "rgba(200,241,53,0.314)" : "#454545"}`,
                boxShadow: featured ? "0 0 32px rgba(200,241,53,0.07)" : "none",
                minHeight: "294px",
              }}
            >
              {/* Tag */}
              <p
                className="text-xs font-black uppercase tracking-widest mb-5"
                style={{ color: "#C8F135" }}
              >
                {tag}
              </p>

              {/* Image */}
              <div className="flex items-center justify-center mb-5" style={{ height: "130px" }}>
                <img
                  src={image}
                  alt={title}
                  className={`${imageSize} object-contain`}
                />
              </div>

              {/* Title */}
              <h3 className="font-semibold mb-2 leading-snug text-white" style={{ fontSize: "21px", lineHeight: "22px" }}>
                {title}
              </h3>

              {/* Detail */}
              <p className="text-base leading-6 mt-1" style={{ color: "#C4C4C4" }}>
                {detail}
              </p>
            </motion.div>
          ))}
        </div>

        {/* Winner announcement box */}
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          className="flex items-center justify-center gap-10 rounded-2xl px-4 py-5 mx-auto"
          style={{ background: "#171717", borderRadius: "16px", maxWidth: "280px" }}
        >
          {/* Left icon */}
          <img src="https://media.base44.com/images/public/69b41710d6b60acb7a810a52/da3e0ce28_trophy_icon.png" alt="trophy" className="w-5 h-5 flex-shrink-0 object-contain" />

          {/* Text */}
          <div className="flex flex-col items-center gap-1">
            <p className="text-base" style={{ color: "#C4C4C4" }}>הכרזת הזוכים</p>
            <p className="font-semibold text-center" style={{ fontSize: "21px", lineHeight: "22px", color: "#C8F135" }}>{config?.announcement_date ?? "31.3.2026"}</p>
          </div>

          {/* Right icon */}
          <img src="https://media.base44.com/images/public/69b41710d6b60acb7a810a52/da3e0ce28_trophy_icon.png" alt="trophy" className="w-5 h-5 flex-shrink-0 object-contain" />
        </motion.div>

      </div>
    </section>
  );
}